import { AfterViewChecked, Component, ElementRef, EventEmitter, Output, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommService } from '../comm.service';
import { Poll, PollWithOptions } from 'src/app/models/message';
import { NotificationService } from 'src/app/shared/notification.service';

@Component({
  selector: 'app-polling',
  templateUrl: './polling.component.html',
  styleUrls: ['./polling.component.less']
})
export class PollingComponent implements AfterViewChecked {

  @Output() pollCreated = new EventEmitter<PollWithOptions>();
  @ViewChildren('optionInput') optionInputs!: QueryList<ElementRef>;

  pollingForm = new FormGroup({
    pollingQuestion: new FormControl('', [Validators.required]),
    //pollingType: new FormControl(1, [Validators.required]),
    newOption: new FormControl('')
  })

  poll: PollWithOptions = {
    pollId: 0,
    inboxMessageGroupId: null,
    createdBy: 0,
    createdDate: new Date(),
    questionText: '',
    typeId: 1,
    responseOptions: []
  };

  private shouldFocusNewOption = false;

  invalidOptions: Set<number> = new Set();
  showValidation = false;

  constructor(private commService: CommService, private notification: NotificationService) {}

  ngAfterViewChecked() {
    if (this.shouldFocusNewOption && this.optionInputs.length > 0) {
      // Focus the last input (the newly created one)
      const lastInput = this.optionInputs.last;
      if (lastInput) {
        lastInput.nativeElement.focus();
        this.shouldFocusNewOption = false;
      }
    }
  }
  
  public validateAllOptions(): boolean {
    this.invalidOptions.clear();
    this.showValidation = true;
    
    this.poll.responseOptions.forEach(option => {
      if (!option.optionText || option.optionText.trim() === '') {
        this.invalidOptions.add(option.pollResponseOptionId);
      }
    });
    
    return this.invalidOptions.size === 0;
  }


  public addNewPoll() {
    if (this.pollingForm.invalid) {
      this.notification.showError('Please fill in all required fields');
      return;
    }
    const newPoll: Poll = {
      pollId: 0,
      inboxMessageGroupId: null,
      createdBy: 0,
      createdDate: new Date(),
      questionText: this.pollingForm.value.pollingQuestion || '',
      typeId:  1
    };

    this.commService.newPoll(newPoll).subscribe({
      next: (response) => {
        this.notification.showSuccess('Poll created successfully');
        this.poll = response;
        this.pollCreated.emit(this.poll);
      },
      error: (error) => {
        this.notification.showError('Error occurred while creating poll:', error);
      }
    })
  }
  
  public addNewOption() {
    // if (!newOptionText || newOptionText.trim() === '') {
    //   this.notification.showError('Option text cannot be empty');
    //   return;
    // }
    const newOption = {
      pollResponseOptionId: 0,
      pollId: this.poll.pollId,
      optionText: '',
      value: this.poll.responseOptions.length + 1
    };
    this.commService.addPollOption(newOption).subscribe({
      next: (response) => {
        //this.notification.showSuccess('Option added successfully');
        this.poll = response;
        //this.pollingForm.patchValue({ newOption: '' });
        this.shouldFocusNewOption = true;
        this.pollCreated.emit(this.poll);
      },
      error: (error) => {
        this.notification.showError('Error occurred while adding option:', error);
      }
    });
  }

  public removePoll() {
    this.commService.deletePoll(this.poll.pollId).subscribe({
      next: (response) => {
        this.notification.showSuccess('Poll removed successfully');
        this.poll = {
          pollId: 0,
          inboxMessageGroupId: null,
          createdBy: 0,
          createdDate: new Date(),
          questionText: '',
          typeId: 1,
          responseOptions: []
        };
        this.pollingForm.reset({ pollingQuestion: '', newOption: '' });
        this.pollCreated.emit(this.poll);
      },
      error: (error) => {
        this.notification.showError('Error occurred while removing poll:', error);
      }
    });
  }

  public updateOptionText(optionId: number, event: Event) {
    const option = this.poll.responseOptions.find(o => o.pollResponseOptionId === optionId);
    if (option) {
      option.optionText = (event.target as HTMLInputElement).value;
      this.commService.addPollOption(option).subscribe({
        next: (response) => {
          this.notification.showSuccess('Option updated successfully');
          this.poll = response;
          this.pollCreated.emit(this.poll);
        },
        error: (error) => {
          this.notification.showError('Error occurred while updating option:', error);
        }
      });
    }
  }

  public deleteOption(optionId: number) {
    if (this.poll.responseOptions.length <= 2) {
      this.notification.showError('At least two options are required');
      return;
    }
    const optionIndex = this.poll.responseOptions.findIndex(o => o.pollResponseOptionId === optionId);
    if (optionIndex !== -1) {
      this.commService.deletePollOption(optionId).subscribe({
        next: (response) => {
          this.poll.responseOptions.splice(optionIndex, 1);
          this.notification.showSuccess('Option removed successfully');
          this.poll = response;
          this.pollCreated.emit(this.poll);
        },
        error: (error) => {
          this.notification.showError('Error occurred while removing option:', error);
        }
      });
    }
  }

  public isOptionInvalid(optionId: number): boolean {
    return this.showValidation && this.invalidOptions.has(optionId);
  }

  public resetPoll() {
    this.poll = {
      pollId: 0,
      inboxMessageGroupId: null,
      createdBy: 0,
      createdDate: new Date(),
      questionText: '',
      typeId: 1,
      responseOptions: []
    };
    this.pollingForm.reset({ pollingQuestion: '', newOption: '' });
  }
}

